// extracted by mini-css-extract-plugin
export default {"wrapper":"yxvQ1N","banner":"zOAniW"};